<template>
    <div v-show="comments">
    <comments-list :comments="comments" :reply="reply" />
    <comment-form
      @handleSubmit="createComment"
      :reply="reply"
      ref="commentForm"
    />
    </div>
</template>

<script>
    import CommentsList from './CommentsList'
    import CommentForm from './CommentForm'
    import axios from 'axios'

    export default {
        name: 'Comments',
        components: {
            CommentForm,
            CommentsList
        },
        props: {
            reply: Boolean,
            commentableType: String,
            commentableId: [Number, String]
        },
        data: function () {
            return {
                comments: null,
                prefix: '.comments_count'
            };
        },
        computed: {
            selector: function () {
                return [
                    this.prefix,
                    this.commentableType,
                    this.commentableId
                ].join('_').toLowerCase();
            },
            count: function () {
                let items = this.comments || [];
                return items.reduce(function(total, comment) {
                    return total + comment.replies.length + 1;
                }, 0);
            }
        },
        watch: {
            count: function (newValue) {
                let elem = document.querySelector(this.selector);
                if (elem) elem.textContent = newValue;
            }
        },
        created () {
            this.fetchComments();
        },
        methods: {
            fetchComments: function() {
                return axios
                    .get("/comments/comments", {
                        params: {
                            commentable_id: this.commentableId,
                            commentable_type: this.commentableType
                        }
                    })
                    .then(response => {
                        this.comments = response.data;
                    });
            },
            createComment: function(content) {
                let payload = {
                    comment: {
                        body: content,
                        commentable_id: this.commentableId,
                        commentable_type: this.commentableType
                    }
                };
                return axios
                    .post("/comments/comments", payload)
                    .then(response => {
                        this.comments.push(response.data);
                        this.$refs.commentForm.resetForm();
                    })
                    .catch(error => {
                        this.handleRequestError(error);
                    })
                    .finally(() => {
                        this.$refs.commentForm.resetSubmitting();
                    });
            },
            handleRequestError: function(error) {
                if (error.response.data.error) {
                    this.$eventHub.$emit('addAlert', {
                        type: 'error',
                        message: error.response.data.error
                    })
                }
            },
        }
    };
</script>
